import * as React from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';

import HtmlContent from '../../util/HtmlContent';
import EditComp from '../../util/EditComp';
import VeryEditor from '../../common/EditorVery/VeryEditor2';
import Service from '../../../util/Service';
import { Button, Stack } from '@mui/material';

const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme }) => ({
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
    variants: [
        {
            props: ({ expand }) => !expand,
            style: {
                transform: 'rotate(0deg)',
            },
        },
        {
            props: ({ expand }) => !!expand,
            style: {
                transform: 'rotate(180deg)',
            },
        },
    ],
}));

export default function ComentarioCard(props) {
    const { card, comentario, setCartao } = props;

    const [showEdit, setShowEdit] = React.useState(false);
    const [html, setHtml] = React.useState(comentario.descricao);

    const refEditor = React.useRef();

    function formataData(time) {
        if (!time) return '';
        const dt = new Date(time);
        return dt.toLocaleDateString() + " " + dt.toLocaleTimeString();
    }
    function handleEditarPagina() {
        console.log('>>>handleEditarPagina<<<');
        setShowEdit(!showEdit);
    }

    function handleSalvaComentario() {

        const dado = {
            idComentario: comentario.id,
            id: card.id,
            descricao: html
        }

        Service.POST('/api/security/projeto/kanban/cardSalvaComentario', dado).then(r => {
            if (r.success) {
                setCartao(r.dado);
                setShowEdit(false);
            } else {
                alert(r.msg);
            }
        }
        );
    }

    return (
        <Card sx={{ width: '100%'}} variant="outlined">
            <CardHeader sx={{ padding:'1px'}}
                avatar={
                    <Avatar sx={{ width: 30, height: 30 }} src={`/api/security/user/avatarImageByLogin/${comentario.user.login}`} />
                }
                title={comentario.user.nome + ' ' + formataData(comentario.dt)}
                action={
                    <EditComp 
                    tip={showEdit?"Editar comentário":"Sair Edição"} action={handleEditarPagina} 
                    edit={true} float={true} 
                    />
                  }
            />
                
            <CardContent sx={{ padding:'0px'}}>
                {!showEdit &&
                    <div>
                        <HtmlContent htmlString={comentario.descricao} edit={true} />
                    </div>}
                {showEdit &&
                    <Stack sx={{ overflow: 'auto', maxWidth: '540px', maxHeight: '380px' }}>
                        <div style={{textAlign:'center'}}>
                            <Button onClick={handleSalvaComentario} variant='outlined'     sx={{m:0.5}} size='small'>Salvar Comentário</Button>
                        </div>
                        <VeryEditor html={html} setHtml={setHtml} 
                            style={{
                                padding: 4, border: '2px solid black', overflow: 'auto', height: '200px'
                            }}
                            ref={refEditor}
                        />                        
                    </Stack>
                }
                
            </CardContent>
        </Card>
    );
}
